import * as tslib_1 from "tslib";
import { observer } from 'mobx-react';
import { CommandBarButton } from 'office-ui-fabric-react/lib/Button';
import { ContextualMenuItemType } from 'office-ui-fabric-react/lib/ContextualMenu';
import { Icon, IconType } from 'office-ui-fabric-react/lib/Icon';
import { Image } from 'office-ui-fabric-react/lib/Image';
import { Label } from 'office-ui-fabric-react/lib/Label';
import { OverflowSet } from 'office-ui-fabric-react/lib/OverflowSet';
import { OptionDescription, OptionsCheckbox } from 'owa-options-controls';
import { shouldAddActionToEnd } from 'owa-surface-actions';
import * as React from 'react';
var DIVIDER_MENU_ITEM_NAME = '-';
var MAX_PINNED_ITEMS = 10;
var styles = require('./SurfaceActionsShared.scss');
var classNames = require('classnames/bind').bind(styles);
var SurfaceActionsShared = /** @class */ (function (_super) {
    tslib_1.__extends(SurfaceActionsShared, _super);
    function SurfaceActionsShared() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onRenderActionCheckboxLabel = function (props, key) {
            var label = _this.props.getDisplayNameFromAction(key);
            var _a = _this.props.getIconNameFromAction(key), iconName = _a.iconName, isImage = _a.isImage;
            var className = classNames(styles.checkbox, isImage ? styles.imageWrapper : '');
            return (React.createElement("div", { className: className },
                isImage ? (React.createElement(Image, { className: styles.actionImage, shouldFadeIn: false, src: iconName })) : (React.createElement(Icon, { iconName: iconName, className: styles.actionIcon })),
                React.createElement(Label, { className: styles.actionLabel },
                    " ",
                    label,
                    " ")));
        };
        _this.onRenderAddinCheckboxLabel = function (props, iconProps, name) {
            var iconType = iconProps.iconType;
            return (React.createElement("div", { className: styles.checkbox },
                React.createElement(Icon, tslib_1.__assign({}, iconProps, { className: iconType == IconType.default ? styles.addinIcon : styles.addinImage })),
                React.createElement(Label, { className: styles.actionLabel },
                    " ",
                    name,
                    " ")));
        };
        _this.onRenderPreviewItem = function (item) {
            var isImage = item.iconProps && item.iconProps.iconType != IconType.default;
            var buttonClassName = classNames(styles.previewButton, {
                isAddin: item.isAddin,
                isImage: isImage,
            });
            var iconClassName = classNames(styles.previewIcon, {
                isAddin: item.isAddin,
                isImage: isImage,
            });
            return (React.createElement(CommandBarButton, { onClick: null, iconProps: item.iconProps, styles: { root: buttonClassName, icon: iconClassName } }));
        };
        _this.onRenderPreviewOverflow = function (overflowItems) {
            overflowItems.forEach(function (item) {
                if (!item.isAddin) {
                    item.iconProps = null; // Hide static action icons in the overflow
                }
            });
            return (React.createElement(CommandBarButton, { menuIconProps: { iconName: 'ChevronDown' }, menuProps: { items: overflowItems }, styles: { root: classNames(styles.previewButton, styles.previewOverflowButton) } }));
        };
        return _this;
    }
    SurfaceActionsShared.prototype.render = function () {
        var _a = this.props, previewImageUri = _a.previewImageUri, previewClassName = _a.previewClassName, description = _a.description;
        var actionCheckboxes = [];
        var addinCheckboxes = [];
        var previewPinnedItems = [];
        var previewOverflowItems = [];
        this.prepareActionsContent(actionCheckboxes, previewPinnedItems, previewOverflowItems);
        this.prepareAddinsContent(addinCheckboxes, previewPinnedItems, previewOverflowItems);
        return (React.createElement("div", { className: styles.sharedWrapper },
            React.createElement(OptionDescription, null, description),
            React.createElement("div", { className: styles.sharedPreviewSection },
                React.createElement(Image, { src: previewImageUri, className: 'flipForRtl' }),
                React.createElement(OverflowSet, { className: previewClassName, items: previewPinnedItems, overflowItems: previewOverflowItems, onRenderItem: this.onRenderPreviewItem, onRenderOverflowButton: this.onRenderPreviewOverflow })),
            React.createElement("div", { className: styles.sharedListSection },
                actionCheckboxes,
                addinCheckboxes)));
    };
    SurfaceActionsShared.prototype.prepareActionsContent = function (actionCheckboxes, previewPinnedItems, previewOverflowItems) {
        var _this = this;
        var _a = this.props, actions = _a.actions, selectedActions = _a.selectedActions, onActionSelected = _a.onActionSelected;
        actions.forEach(function (action) {
            var isPinned = selectedActions.indexOf(action) >= 0;
            if (action != DIVIDER_MENU_ITEM_NAME) {
                // If the action isn't a divider, create a OptionsCheckbox for it.
                actionCheckboxes.push(React.createElement(OptionsCheckbox, { checked: isPinned, onChange: function (event, checked) {
                        onActionSelected(selectedActions, action, checked);
                    }, key: action, onRenderLabel: function (props) {
                        return _this.onRenderActionCheckboxLabel(props, action);
                    }, styles: { label: styles.checkBoxLabel, root: styles.checkBoxRoot } }));
                // If the action is pinned, push a preview of it to the proper collection
                if (isPinned) {
                    var _a = _this.props.getIconNameFromAction(action), fallbackIconName = _a.fallbackIconName, isImage = _a.isImage;
                    var previewAction = {
                        key: action,
                        isAddin: false,
                        iconProps: {
                            iconName: fallbackIconName,
                            iconType: isImage ? IconType.Image : IconType.default,
                            imageProps: isImage
                                ? { shouldFadeIn: false, src: fallbackIconName }
                                : null,
                        },
                        name: _this.props.getDisplayNameFromAction(action),
                    };
                    _this.addPreviewItem(previewAction, previewPinnedItems, previewOverflowItems);
                }
            }
        });
    };
    SurfaceActionsShared.prototype.prepareAddinsContent = function (addinCheckboxes, previewPinnedItems, previewOverflowItems) {
        var _this = this;
        var _a = this.props, addins = _a.addins, selectedAddins = _a.selectedAddins, onAddinSelected = _a.onAddinSelected;
        addins.forEach(function (addin) {
            var isPinned = selectedAddins.indexOf(addin.key) >= 0;
            if (addin.itemType == ContextualMenuItemType.Normal) {
                addinCheckboxes.push(React.createElement(OptionsCheckbox, { checked: isPinned, onChange: function (event, checked) {
                        onAddinSelected(selectedAddins, addin.key, checked);
                    }, key: addin.key, onRenderLabel: function (props) {
                        return _this.onRenderAddinCheckboxLabel(props, addin.iconProps, addin.name);
                    }, styles: { label: styles.checkBoxLabel } }));
                // If the addin is pinned, push a preview of it to the proper collection
                if (isPinned) {
                    var previewAddin = {
                        key: addin.key,
                        isAddin: true,
                        iconProps: addin.iconProps,
                        name: addin.name,
                    };
                    _this.addPreviewItem(previewAddin, previewPinnedItems, previewOverflowItems);
                }
            }
        });
    };
    SurfaceActionsShared.prototype.addPreviewItem = function (item, pinnedItems, overflowItems) {
        var isLeftToRight = this.props.isLeftToRight;
        // If we have fewer than the max pinned items and no overflow items, push to the pinned collection.
        if (pinnedItems.length < MAX_PINNED_ITEMS && overflowItems.length == 0) {
            if (isLeftToRight || shouldAddActionToEnd(item.key)) {
                pinnedItems.push(item);
            }
            else {
                pinnedItems.unshift(item);
            }
        }
        else if (pinnedItems.length == MAX_PINNED_ITEMS) {
            // Otherwise, if we have exactly the max amount of pinned items, remove one and add it to the overflow along with the new item.
            overflowItems.push(isLeftToRight ? pinnedItems.pop() : pinnedItems.shift());
            overflowItems.push(item);
        }
        else {
            // Otherwise push to the overflow.
            overflowItems.push(item);
        }
    };
    SurfaceActionsShared = tslib_1.__decorate([
        observer
    ], SurfaceActionsShared);
    return SurfaceActionsShared;
}(React.Component));
export default SurfaceActionsShared;
//# sourceMappingURL=SurfaceActionsShared.js.map